import { PaymentType } from '@/core/models/consultation.model'
import { useTranslation } from 'react-i18next'
import * as yup from 'yup'

export type ConsultationValidationFormValues = {
    price: number
    paymentType: PaymentType
}

export default function useConsultationValidationFormSchema() {
    const { t } = useTranslation()

    return yup.object().shape({
        price: yup
            .number()
            .required(t('validation.required'))
            .min(0, t('validation.min', { min: 0 })),
        paymentType: yup
            .string()
            .oneOf(Object.values(PaymentType), t('validation.invalid'))
            .required(t('validation.required')),
    })
} 